export default __webpack_public_path__ + "static/media/fridge1-before2-768w.4f652d18.webp";